import React, { useState } from 'react';

import { useLoginApi } from '../../../api/login/useLoginApi';
import { useSystemUserApi } from '../../../api/system-user/useSystemUserApi';

import DeleteAccount from '../../../components/screens/auth/delete-account/DeleteAccount';

const DeleteAccountContainer = () => {
  const [accountDeleted, setAccountDeleted] = useState(false);

  const { login } = useLoginApi();

  const { deleteAccount } = useSystemUserApi();

  const handleDeleteAccountClick = (email: string, password: string) => {
    login({ email, password, deleteAccount: true }, () => {
      deleteAccount(() => setAccountDeleted(true));
    });
  };

  return <DeleteAccount accountDeleted={accountDeleted} handleDeleteAccountClick={handleDeleteAccountClick} />;
};

export default DeleteAccountContainer;
